import { ScrollingModule } from '@angular/cdk/scrolling';
import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule, MatFormFieldModule, MatInputModule, MatSidenavModule } from '@angular/material';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CarouselModule, MDBBootstrapModule } from 'angular-bootstrap-md';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { MatTableExporterModule } from 'mat-table-exporter';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgxSpinnerModule } from "ngx-spinner";
import { ToastrModule } from 'ngx-toastr';
import { FileService } from 'src/app/services/file.service';
import { MenuItemService } from 'src/app/services/menu.item.service';
import { UserService } from 'src/app/services/user.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MenuAdminComponent } from './core/menu-admin/menu-admin.component';
import { MenuIndividualComponent } from './core/menu-individual/menu-individual.component';
import { MenuPhysicalStoreComponent } from './core/menu-physical-store/menu-physical-store.component';
import { MenuRoleComponent } from './core/menu-role/menu-role.component';
import { MenuShipmentComponent } from './core/menu-shipment/menu-shipment.component';
import { MenuStockManagementComponent } from './core/menu-stock-management/menu-stock-management.component';
import { MenuComponent } from './core/menu/menu.component';
import { ChangePasswordComponent } from './modules/components/home/change-password/change-password.component';
import { ConfirmOrdersComponent } from './modules/components/home/confirm-orders/confirm-orders.component';
import { ContactComponent } from './modules/components/home/contact/contact.component';
import { ForgotPasswordComponent } from './modules/components/home/forgot-password/forgot-password.component';
import { HomeComponent } from './modules/components/home/home/home.component';
import { InstructionsComponent } from './modules/components/home/instructions/instructions.component';
import { LoginAvetComponent } from './modules/components/home/login-avet/login-avet.component';
import { LoginComponent } from './modules/components/home/login/login.component';
import { AppBlockComponent } from './modules/components/home/maintenance/app-block/app-block.component';
import { ClothesManagementComponent } from './modules/components/home/maintenance/clothes-management/clothes-management.component';
import { FamilyComponent } from './modules/components/home/maintenance/family/family.component';
import { FilesComponent } from './modules/components/home/maintenance/files/files.component';
import { RolComponent } from './modules/components/home/maintenance/rol/rol.component';
import { StockComponent } from './modules/components/home/maintenance/stock/stock.component';
import { ManipulationOrderComponent } from './modules/components/home/manipulation-order/manipulation-order.component';
import { MyAccountComponent } from './modules/components/home/my-account/my-account.component';
import { MyOrdersComponent } from './modules/components/home/my-orders/my-orders.component';
import { MyPinesComponent } from './modules/components/home/my-pines/my-pines.component';
import { NocSizesComponent } from './modules/components/home/noc-sizes/noc-sizes.component';
import { OrderRequestComponent } from './modules/components/home/order-request/order-request.component';
import { PinGeneratorComponent } from './modules/components/home/pin-generator/pin-generator.component';
import { PinResultComponent } from './modules/components/home/pin-result/pin-result.component';
import { PrivacyPolicyComponent } from './modules/components/home/privacy-policy/privacy-policy.component';
import { CloseDayComponent } from './modules/components/home/reports/close-day/close-day.component';
import { OrderTrackingReportComponent } from './modules/components/home/reports/order-tracking-report/order-tracking-report.component';
import { OrdersFinishedReportComponent } from './modules/components/home/reports/orders-finished-report/orders-finished-report.component';
import { OrdersPostalDataReportComponent } from './modules/components/home/reports/orders-postal-data-report/orders-postal-data-report.component';
import { OrdersPreparationReportComponent } from './modules/components/home/reports/orders-preparation-report/orders-preparation-report.component';
import { OrdersReportComponent } from './modules/components/home/reports/orders-report/orders-report.component';
import { ReturnsReportComponent } from './modules/components/home/reports/returns-report/returns-report.component';
import { SalesPricesReportComponent } from './modules/components/home/reports/sales-prices-report/sales-prices-report.component';
import { StockReportComponent } from './modules/components/home/reports/stock-report/stock-report.component';
import { StoreMovementReportComponent } from './modules/components/home/reports/store-movement-report/store-movement-report.component';
import { ReturnsComponent } from './modules/components/home/returns/returns.component';
import { ShipmentOrderComponent } from './modules/components/home/shipment-order/shipment-order.component';
import { ShoppingCartComponent } from './modules/components/home/shopping-cart/shopping-cart.component';
import { StoreOrderRequestComponent } from './modules/components/home/store-order-request/store-order-request.component';
import { AuthenticationService } from './services/authentication.service';
import { BlockService } from './services/block.service';
import { FamilyService } from './services/family.service';
import { MessagesService } from './services/messages.service';
import { ObservationService } from './services/observation.service';
import { OrderService } from './services/order.service';
import { PasswordService } from './services/password.service';
import { PermissionService } from './services/permission.service';
import { PinService } from './services/pin.service';
import { RouteService } from './services/routeService';
import { ShareDataService } from './services/shareData.service';
import { TokenInterceptorService } from './services/token-interceptor.service';
import { AuthGuard } from './shared/guards/auth.guard';
import { AsPipe } from './utils/pipes/as.pipe';
import { FilterPipe } from './utils/pipes/filter.pipe';
registerLocaleData(localeFr);

@NgModule({
  declarations: [
    AppComponent,
    MenuComponent,
    LoginComponent,
    ChangePasswordComponent,
    ContactComponent,
    ForgotPasswordComponent,
    HomeComponent,
    //PdfViewerComponent,
    MenuAdminComponent,
    MenuPhysicalStoreComponent,
    MenuStockManagementComponent,
    MenuIndividualComponent,
    MyAccountComponent,
    LoginAvetComponent,
    ClothesManagementComponent,
    FamilyComponent,
	  NocSizesComponent,
    RolComponent,
    MenuRoleComponent,
	  StockComponent,
    PrivacyPolicyComponent,
    InstructionsComponent,
    OrderRequestComponent,
    AsPipe,
    ShoppingCartComponent,
    OrderRequestComponent,
    StoreMovementReportComponent,
    SalesPricesReportComponent,
    OrdersReportComponent,
    OrdersPostalDataReportComponent,
    ConfirmOrdersComponent,
    MyOrdersComponent,
    FilterPipe,
    MenuShipmentComponent,
    ManipulationOrderComponent,
    ShipmentOrderComponent,
    StoreOrderRequestComponent,
    OrderTrackingReportComponent,
    OrdersPreparationReportComponent,
    OrdersFinishedReportComponent,
    PinGeneratorComponent,
    PinResultComponent,
    MyPinesComponent,
		AppBlockComponent,
    StockReportComponent,
    CloseDayComponent,
    ReturnsComponent,
    FilesComponent,
    ReturnsReportComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AppRoutingModule,
    MDBBootstrapModule.forRoot(),
    BrowserAnimationsModule,
    HttpClientModule,
    NgxSpinnerModule,
    ReactiveFormsModule,
    ToastrModule.forRoot(),
    AutocompleteLibModule,
    MatTableModule,
    MatTableExporterModule,
    MatButtonModule,
    PdfViewerModule,
    ScrollingModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatGridListModule,
    MatSidenavModule,
    MatSortModule,
    MDBBootstrapModule,
    CarouselModule.forRoot()
  ],
  providers: [
    AuthenticationService,
    MessagesService,
    PasswordService,
    UserService,
    FileService,
    AuthGuard,
    MenuItemService,
    FamilyService,
    PermissionService,
    OrderService,
    RouteService,
    ShareDataService,
    PinService,
    ObservationService,
	    BlockService,
    { provide: LOCALE_ID, useValue: 'fr-FR'},
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptorService,
      multi: true,
    }],
  bootstrap: [AppComponent]
})
export class AppModule { }
